import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Endpoint } from "../shared/endpoints";
import { VersionSummary } from "../models/versioning.model";

@Injectable({
  providedIn: "root",
})
export class VersioningService {
  constructor(private http: HttpClient) {}

  // Flow
  getFlowVersionHistory(logicalFlowId: string): Observable<VersionSummary[]> {
    const params = { logicalFlowId };
    return this.http.get<VersionSummary[]>(
      environment.apiBaseUrl + Endpoint.flowVersionHistoryUrl,
      { params }
    );
  }

  getFlowByVersion(logicalFlowId: string, version: number): Observable<any> {
    const params = { logicalFlowId, version: version.toString() };
    return this.http.get<any>(
      environment.apiBaseUrl + Endpoint.flowByVersionUrl,
      { params }
    );
  }

  createFlowVersion(
    logicalFlowId: string,
    updatedFlow: any
  ): Observable<any> {
    const body = { logicalFlowId, updatedFlow };
    return this.http.post<any>(
      environment.apiBaseUrl + Endpoint.createFlowVersionUrl,
      body
    );
  }

  restoreFlowVersion(
    logicalFlowId: string,
    version: number
  ): Observable<any> {
    const body = { logicalFlowId, version };
    return this.http.post<any>(
      environment.apiBaseUrl + Endpoint.restoreFlowVersionUrl,
      body
    );
  }

  deleteFlowVersion(
    logicalFlowId: string,
    version: number
  ): Observable<any> {
    const body = { logicalFlowId, version };
    return this.http.post<any>(
      environment.apiBaseUrl + Endpoint.deleteFlowVersionUrl,
      body
    );
  }

  // Bundle
  getBundleVersionHistory(
    logicalBundleId: string
  ): Observable<VersionSummary[]> {
    const params = { logicalBundleId };
    return this.http.get<VersionSummary[]>(
      environment.apiBaseUrl + Endpoint.bundleVersionHistoryUrl,
      { params }
    );
  }

  getBundleByVersion(
    logicalBundleId: string,
    version: number
  ): Observable<any> {
    const params = { logicalBundleId, version: version.toString() };
    return this.http.get<any>(
      environment.apiBaseUrl + Endpoint.bundleByVersionUrl,
      { params }
    );
  }

  createBundleVersion(
    logicalBundleId: string,
    updatedBundle: any
  ): Observable<any> {
    const body = { logicalBundleId, updatedBundle };
    return this.http.post<any>(
      environment.apiBaseUrl + Endpoint.createBundleVersionUrl,
      body
    );
  }

  restoreBundleVersion(
    logicalBundleId: string,
    version: number
  ): Observable<any> {
    const body = { logicalBundleId, version };
    return this.http.post<any>(
      environment.apiBaseUrl + Endpoint.restoreBundleVersionUrl,
      body
    );
  }

  deleteBundleVersion(
    logicalBundleId: string,
    version: number
  ): Observable<any> {
    const body = { logicalBundleId, version };
    return this.http.post<any>(
      environment.apiBaseUrl + Endpoint.deleteBundleVersionUrl,
      body
    );
  }
}

